import { authService, userService } from '../../lib/services'
import userManager from '../../lib/userManager'

export async function setActAsFun(data, params, setActAs, setOUser) {
    const response = await authService.ActAs(params)
    if (response) {
        setActAs(data)
        updateActAsData(setOUser)
    }
}

export async function deActAsFun(params, setActAs, setOUser) {
    const response = await authService.DeActAs(params)
    if (response) {
        setActAs(null)
        updateActAsData(setOUser)
    }
}

export const updateActAsData = async setOUser => {
    userManager
        .signinSilent()
        .then(async () => {
            const user = await userManager.getUser()
            if (user) {
                setOUser(user)
            }
        })
        .catch(e => console.error(e))
}
